var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.cards[_vm.item.type],{tag:"component",attrs:{"item":_vm.item,"selected":_vm.selected,"compact":_vm.compact},on:{"showEmailAttachments":function($event){return _vm.$emit('showEmailAttachments', $event)}},nativeOn:{"click":function($event){return _vm.$emit('select', _vm.item)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }